<div class="px-3 md:px-4 md:py-0 sm:py-0 max-w-[900px] mx-auto">
  <!-- Header -->
  <header class="mb-6 flex items-start gap-3">
    @if (isSmallSceen()) {
      <button
        mat-icon-button
        class="w-10 h-10 rounded-xl bg-white border border-gray-200 shadow-sm flex items-center justify-center text-gray-500 hover:bg-gray-50 transition-colors shrink-0 mt-0.5"
        (click)="sidenavService.toggle()"
        [matTooltip]="(sidenavService.opened() ? 'Global.Close' : 'Global.Open') | translate"
      >
        <mat-icon class="text-[20px]! w-5! h-5!">{{ sidenavService.opened() ? 'left_panel_close' : 'left_panel_open' }}</mat-icon>
      </button>
    }
    <div class="flex-1 min-w-0">
      <h1 class="text-2xl font-bold mb-1">{{ 'UserManagement.Title' | translate }}</h1>
      <p class="text-sm text-gray-500">{{ 'UserManagement.Subtitle' | translate }}</p>
    </div>
  </header>

  <!-- Main Card -->
  <div class="bg-white rounded-2xl border border-gray-200 mb-8 overflow-hidden">
    <!-- Toolbar -->
    <div class="p-3 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <mat-form-field appearance="fill" subscriptSizing="dynamic" class="flex-1 soft-input">
        <mat-icon matPrefix class="text-gray-400 mr-2">search</mat-icon>
        <input matInput [placeholder]="'UserManagement.SearchPlaceholder' | translate" [(ngModel)]="searchInput" (ngModelChange)="onSearchChange()" />
      </mat-form-field>
      <div class="flex items-center gap-2">
        @if (pendingInvitations().length > 0) {
          <button
            mat-icon-button
            btnType="action-icon"
            [matTooltip]="'UserManagement.PendingInvitations' | translate"
            (click)="togglePendingInvitationsBanner()"
            class="sm:shrink-0 relative"
            [class.bg-blue-50]="showPendingInvitationsBanner()"
            [class.text-blue-600]="showPendingInvitationsBanner()"
          >
            <mat-icon>schedule_send</mat-icon>
            <div class="absolute -top-1 -right-1 w-4 h-4 bg-[#5a73c5] rounded-full border-[2px] border-white text-[9px] font-bold text-white flex items-center justify-center">
              {{ pendingInvitations().length }}
            </div>
          </button>
        }
        <button
          mat-icon-button
          btnType="action-icon"
          [matTooltip]="'UserManagement.ShareJoinLink' | translate"
          (click)="toggleJoinLinkBanner()"
          class="sm:shrink-0"
          [class.bg-blue-50]="showJoinLinkBanner()"
          [class.text-blue-600]="showJoinLinkBanner()"
        >
          <mat-icon>link</mat-icon>
        </button>
        <button mat-flat-button btnType="action" color="primary" (click)="openCreateDialog()" class="sm:shrink-0">
          {{ 'UserManagement.InviteUser' | translate }}
        </button>
      </div>
    </div>

    <!-- Pending Invitations Banner -->
    @if (showPendingInvitationsBanner() && pendingInvitations().length > 0) {
      <div class="bg-white mb-2 overflow-hidden border-t border-gray-100">
        <div class="px-6 py-4 !bg-[#fafafa] flex flex-col gap-1.5">
          <div class="flex items-center gap-4">
            <h3 class="text-[16px] font-semibold text-[#111827] m-0">
              {{ 'UserManagement.PendingInvitations' | translate }}
            </h3>
          </div>
          <p class="text-[13px] text-[#6b7280] m-0">
            {{ 'UserManagement.PendingInvitationsSubtitle' | translate }}
          </p>
        </div>
        <div class="max-h-[250px] overflow-y-auto custom-scrollbar">
          @if (pendingInvitationsLoading()) {
            <div class="px-6 py-4">
              <ui-skeleton type="join-links" [noPadding]="true" />
            </div>
          } @else {
            @for (invite of pendingInvitations(); track invite._id; let last = $last) {
              <div class="relative flex flex-col md:flex-row md:items-center gap-4 px-6 py-4 transition-colors group">
                <!-- Row Info (left side) -->
                <div class="flex items-center gap-3 flex-1 min-w-0">
                  <div class="w-10 h-10 rounded-[var(--skz-radius-low)] bg-[#f0f3fc] text-[var(--skz-icon-color-blue)] flex items-center justify-center shrink-0">
                    <mat-icon>person</mat-icon>
                  </div>
                  <div class="min-w-0 flex-1">
                    <div class="flex items-center gap-2 mb-1 flex-wrap">
                      <h4 class="text-[14px] font-semibold text-[#374151] m-0">{{ invite.email }}</h4>
                      <mat-chip-set class="inline-flex">
                        <mat-chip>
                          {{ 'Roles.' + (invite.role | titlecase) | translate }}
                        </mat-chip>
                      </mat-chip-set>
                    </div>
                    <p class="text-[13px] text-[#6b7280] m-0 truncate">{{ 'UserManagement.SentOn' | translate }} {{ invite.createdAt | date: 'mediumDate' }}</p>
                  </div>
                </div>

                <!-- Row Controls (right side) -->
                <div class="flex items-center gap-2 shrink-0">
                  <button mat-icon-button btnType="action-icon" (click)="resendInvite(invite)" [disabled]="isResending(invite._id)" [matTooltip]="'UserManagement.Resend' | translate">
                    @if (isResending(invite._id)) {
                      <mat-spinner diameter="18"></mat-spinner>
                    } @else {
                      <mat-icon>send</mat-icon>
                    }
                  </button>
                  <button mat-icon-button btnType="action-icon" (click)="cancelInvite(invite, $event)" [matTooltip]="'UserManagement.CancelInvite' | translate" class="hover:text-red-500">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>

                <!-- Inset divider (except last row) -->
                @if (!last) {
                  <div class="absolute bottom-0 left-6 right-6 h-px bg-[var(--skz-border-color-main)]"></div>
                }
              </div>
            }
          }
        </div>
      </div>
    }

    <!-- Shareable Join Links Section — Settings Card Pattern -->
    @if (showJoinLinkBanner()) {
      @if (joinLinksLoading()) {
        <ui-skeleton type="join-links" [noPadding]="true" />
      } @else {
        <div class="bg-white mb-2 overflow-hidden">
          <div class="px-6 py-4 bg-[#fafafa] flex flex-col gap-1.5">
            <div class="flex items-center gap-4">
              <h3 class="text-[16px] font-semibold text-[#111827] m-0">
                {{ 'UserManagement.ShareJoinLinkTitle' | translate }}
              </h3>
              <button
                mat-icon-button
                [matTooltip]="'UserManagement.NewJoinLink' | translate"
                (click)="openCreateJoinLinkDialog()"
                class="!bg-[var(--skz-icon-color-blue)] !text-white shadow-sm hover:brightness-95 shrink-0"
              >
                <mat-icon>add</mat-icon>
              </button>
            </div>
            <p class="text-[13px] text-[#6b7280] m-0">
              {{ 'UserManagement.ShareJoinLinkSubtitle' | translate }}
            </p>
          </div>

          <!-- Link Rows (matches settings-row pattern) -->
          <div class="max-h-[250px] overflow-y-auto custom-scrollbar">
            @for (link of joinLinks(); track link._id; let last = $last) {
              <div class="relative flex flex-col md:flex-row md:items-center gap-4 px-6 py-4 transition-colors group" [class.opacity-50]="!link.enabled">
                <!-- Row Info (left side) -->
                <div class="flex items-center gap-3 flex-1 min-w-0">
                  <div
                    class="w-10 h-10 rounded-[var(--skz-radius-low)] bg-[#f0f3fc] text-[var(--skz-icon-color-blue)] flex items-center justify-center shrink-0 cursor-pointer transition-colors hover:bg-[#dce4f8]"
                    (click)="openQrModalForLink(link)"
                    [matTooltip]="'UserManagement.ShowQrCode' | translate"
                  >
                    <mat-icon>qr_code_2</mat-icon>
                  </div>
                  <div class="min-w-0 flex-1">
                    <div class="flex items-center gap-2 mb-1 flex-wrap">
                      <h4 class="text-[14px] font-semibold text-[#374151] m-0">{{ link.name }}</h4>
                      <mat-chip-set class="inline-flex">
                        <mat-chip>
                          {{ getGroupName(link.groupId) }}
                        </mat-chip>
                        @if (link.allowedDomain) {
                          <mat-chip class="!bg-slate-50 !text-slate-700 !border-slate-200" [matTooltip]="'UserManagement.DomainLockActiveTooltip' | translate">&#64;{{ link.allowedDomain }}</mat-chip>
                        }
                      </mat-chip-set>
                    </div>
                    <p class="text-[13px] text-[#6b7280] m-0 truncate">{{ link.joinUrl }}</p>
                  </div>
                </div>

                <!-- Row Controls (right side) -->
                <div class="flex items-center gap-2 shrink-0">
                  <mat-slide-toggle
                    dense
                    [checked]="link.enabled"
                    [matTooltip]="(link.enabled ? 'UserManagement.DisableLink' : 'UserManagement.EnableLink') | translate"
                    (change)="toggleJoinLinkItemStatus(link)"
                    color="primary"
                    class="me-6"
                  />
                  <button mat-icon-button btnType="action-icon" (click)="copyLinkUrl(link.joinUrl)" [matTooltip]="'UserManagement.CopyLink' | translate">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  <button mat-icon-button btnType="action-icon" (click)="openEditJoinLinkDialog(link)" [matTooltip]="'Global.Edit' | translate" class="text-gray-400 hover:text-gray-600">
                    <mat-icon>edit</mat-icon>
                  </button>
                  @if (joinLinks().length > 1) {
                    <button mat-icon-button btnType="action-icon" (click)="deleteJoinLinkItem(link, $event)" [matTooltip]="'Global.Delete' | translate">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  }
                </div>

                <!-- Inset divider (except last row) -->
                @if (!last) {
                  <div class="absolute bottom-0 left-6 right-6 h-px bg-[var(--skz-border-color-main)]"></div>
                }
              </div>
            }
          </div>
        </div>
      }
    }

    @if (loading() && usersDataSource.data.length === 0) {
      <div class="p-4">
        <ui-skeleton type="user-table" [count]="4" [noPadding]="true" />
      </div>
    }

    <!-- Desktop Table View -->
    @if (!showTiles() && (!loading() || usersDataSource.data.length > 0)) {
      <div class="max-h-[calc(100vh-280px)] overflow-y-auto custom-scrollbar" (scroll)="onTableScroll($event)">
        <table mat-table [dataSource]="usersDataSource" matSort (matSortChange)="onSortChange($event)" class="w-full">
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left font-semibold py-2 px-4 border-b border-gray-100">
              {{ 'ManageUser.Email' | translate }}
            </th>
            <td mat-cell *matCellDef="let user" class="py-2 px-4 border-b border-gray-100 text-sm text-gray-700">{{ user.email }}</td>
          </ng-container>

          <ng-container matColumnDef="fullName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-left font-semibold py-2 px-4 border-b border-gray-100">
              {{ 'ManageUser.FullName' | translate }}
            </th>
            <td mat-cell *matCellDef="let user" class="py-2 px-4 border-b border-gray-100 text-sm text-gray-700 capitalize">
              {{ user.firstName || user.lastName ? (user.firstName + ' ' + user.lastName).trim() : user.name }}
            </td>
          </ng-container>

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef class="text-left font-semibold py-2 px-4 border-b border-gray-100">
              {{ 'UserManagement.Role' | translate }}
            </th>
            <td mat-cell *matCellDef="let user" class="py-2 px-4 border-b border-gray-100">
              <app-role-picker
                [value]="user.role || 'user'"
                [options]="roleOptions"
                [disabled]="!currentUserData || currentUserData.type?.toLowerCase() !== 'admin' || isCurrentUser(user._id)"
                (valueChange)="onRoleChange(user, $event)"
              />
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="text-right py-2 px-4 border-b border-gray-100">
              {{ 'ManageUser.Actions' | translate }}
            </th>
            <td mat-cell *matCellDef="let user" class="py-2 px-4 border-b border-gray-100 text-right">
              @if (currentUserData?.type?.toLowerCase() === 'admin' && !isCurrentUser(user._id)) {
                <button mat-icon-button (click)="deleteUser(user, $event)" class="text-red-500 hover:bg-red-50 transition-colors">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="bg-gray-50"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="hover:bg-gray-50/50 transition-colors"></tr>
        </table>

        @if (!loading() && usersDataSource.data.length === 0) {
          <div class="flex flex-col items-center justify-center py-16 px-6 text-gray-500">
            <mat-icon class="text-4xl w-12 h-12 mb-3 opacity-50">group_off</mat-icon>
            <p class="text-sm m-0">{{ 'UserManagement.NoUsers' | translate }}</p>
          </div>
        }

        @if (loadingMore()) {
          <div class="flex justify-center py-4 border-t border-gray-100">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        }
      </div>
    }

    <!-- Tablet + Mobile Tile View -->
    @if (showTiles()) {
      <div class="max-h-[calc(100vh-280px)] overflow-y-auto custom-scrollbar divide-y divide-gray-100" (scroll)="onTableScroll($event)">
        @for (user of usersDataSource.data; track user._id) {
          <div class="flex items-center gap-3 px-4 py-3 hover:bg-gray-50/50 transition-colors group">
            <!-- Avatar -->
            <div class="w-9 h-9 rounded-full bg-indigo-50 flex items-center justify-center shrink-0 text-sm font-bold text-indigo-600">
              {{ (user.firstName || user.email)?.charAt(0)?.toUpperCase() }}
            </div>

            <!-- Info -->
            <div class="flex-1 min-w-0">
              <p class="text-sm font-semibold text-gray-800 truncate mb-0">
                {{ user.firstName || user.lastName ? (user.firstName + ' ' + user.lastName).trim() : user.email }}
              </p>
              <p class="text-xs text-gray-400 truncate mb-0">{{ user.email }}</p>
            </div>

            <!-- Role picker -->
            <div class="shrink-0">
              <app-role-picker
                [value]="user.role || 'user'"
                [options]="roleOptions"
                [disabled]="!currentUserData || currentUserData.type?.toLowerCase() !== 'admin' || isCurrentUser(user._id)"
                (valueChange)="onRoleChange(user, $event)"
              />
            </div>

            <!-- Delete -->
            @if (currentUserData?.type?.toLowerCase() === 'admin' && !isCurrentUser(user._id)) {
              <button mat-icon-button (click)="deleteUser(user, $event)" class="text-red-400 hover:text-red-600 opacity-0 group-hover:opacity-100 transition-all shrink-0">
                <mat-icon>delete_outline</mat-icon>
              </button>
            }
          </div>
        }

        @if (!loading() && usersDataSource.data.length === 0) {
          <div class="flex flex-col items-center justify-center py-16 px-6 text-gray-500">
            <mat-icon class="text-4xl w-12 h-12 mb-3 opacity-50">group_off</mat-icon>
            <p class="text-sm m-0">{{ 'UserManagement.NoUsers' | translate }}</p>
          </div>
        }

        @if (loadingMore()) {
          <div class="flex justify-center py-4 border-t border-gray-100">
            <mat-spinner diameter="30"></mat-spinner>
          </div>
        }
      </div>
    }
  </div>
</div>
